import {
  isUserType,
  ItemInfoType,
  TeamType,
  UserType,
} from "@fixa/notifications";

function getFormattedItemIdString(numberString: string) {
  return numberString.match(/.{1,3}/g)?.join(".") ?? "";
}

export function getItemNameIdString(itemInfo: ItemInfoType | null): string {
  if (!itemInfo || (!itemInfo.name && !itemInfo.id)) {
    return "";
  }

  const { name, id } = itemInfo;
  if (name && id) {
    return `${name}  \u{02022}  ${getFormattedItemIdString(id)}`;
  } else if (id) {
    return getFormattedItemIdString(id);
  } else {
    return name;
  }
}

function getUserAssignerString({ firstName, lastName, fullName }: UserType) {
  if (firstName && lastName) {
    return `${firstName} ${Array.from(lastName)[0]}.`;
  } else if (firstName) {
    return firstName;
  } else if (lastName) {
    return lastName;
  } else if (fullName) {
    return fullName;
  }
  return "";
}

export function getBodyAssignerString(assigner: UserType | TeamType) {
  if (isUserType(assigner)) {
    return getUserAssignerString(assigner);
  } else {
    return assigner.name;
  }
}
